module.exports = __webpack_public_path__ + "img/tile_02.830ef766.jpg";